import { modelBaseUrl, guestKey } from './constants';

class CancelablePromise extends Promise {
    constructor(executor, abortController) {
        super((resolve, reject) => {
            return executor(resolve, reject);
        });
        this.abortController = abortController;
    }

    abort() {
        return this.abortController?.abort();
    }
}

export const callApi = (endpoint, key = guestKey, data = {}, bodyData) => {
    const controller = new AbortController();
    const signal = controller.signal;
    return new CancelablePromise((resolve, reject) => {
        const trimmedEndpoint =
            endpoint.startsWith('/') || endpoint.startsWith('\\')
                ? endpoint.slice(1)
                : endpoint;

        const query = new URLSearchParams({
            ...data,
            key,
            type: trimmedEndpoint,
        });

        const url = `${modelBaseUrl}?${query}`;

        const options = { signal };
        options.method = 'POST';
        options.redirect = 'follow';
        if (bodyData) {
            options.method = 'POST';
            options.headers = {
                'Content-Type': 'application/json',
            };
            options.body = JSON.stringify(bodyData);
            // options.headers = {
            //     'Content-Type': 'multipart/form-data',
            //     // 'Content-Type': 'application/x-www-form-urlencoded',
            // };
            // const formData = new FormData();
            // for (const name in bodyData) {
            //     formData.append(name, bodyData[name]);
            // }
            // options.body = formData;
        }

        fetch(url, options)
            .then(async (response) => {
                if (response.status >= 200 && response.status < 300) {
                    const responseData = await response.json();
                    console.log('success responseData:', responseData);
                    if (
                        responseData.responsecode === 0 ||
                        (responseData.responsecode >= 200 &&
                            responseData.responsecode < 300)
                    ) {
                        resolve(responseData.data);
                    } else {
                        const errorMsg =
                            responseData.responsemsg || 'server error';
                        reject(new Error(errorMsg));
                    }
                } else {
                    let jsonData;
                    try {
                        jsonData = await response.json();
                    } catch (error) {}
                    console.log('error responseData:', jsonData);
                    reject(jsonData ?? 'Server error');
                }
            })
            .catch((err) => {
                if (err instanceof DOMException && err.name === 'AbortError') {
                    console.log('Request aborted');
                    // reject(null);
                    return;
                }
                reject(err);
            });
    }, controller);
};
